// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/hand-patterns/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const handPatternsEN: PageEntry = {
  id: "post.handmuster",
  locale: "en",
  slug: "hand-patterns",
  seo: {
    title: "Glossary: Hand patterns explained simply | Dietz GmbH",
    description: "Hand sample refers to a manually produced sample or prototype of a spring that has been made by hand before actual mass production begins. Hand samples are used to check the design",
  },
  type: "post",
  h1: "Glossary: Hand patterns explained simply",
  intro: "Hand sample refers to a manually produced sample or prototype of a spring that has been made by hand before actual mass production begins. Hand samples are used to check the design and functionality of a spring before expensive moulds and machinery are used. Engineers and designers use hand samples to ensure that the spring meets the specified requirements and to make any necessary adjustments before mass production. The creation of hand samples is an important phase in the development of new spring designs.",
  blocks: [

  ],
};
